<template>
  <div>
    <app-header title=""></app-header>

    <div class="container my-5">
      <h2>Warranties</h2>

      <warranties-list-filters v-model="params" />

      <c-data-list class="no-links no-hover" :items="rows" key-by="key">
        <template v-slot:columns>
          <div class="col-12 col-lg-5">
            <p>Client / Project</p>
          </div>
          <div class="col-6 col-lg-2">
            <p>Evaluation End</p>
          </div>
          <div class="col-6 col-lg-3">
            <p>Warranty Period</p>
          </div>
          <div class="col-6 col-lg-2 text-end">
            <p>Status</p>
          </div>
        </template>
        <template v-slot:default="slotProps">
          <warranties-list-item :warranty="slotProps.item" />
        </template>
        <template v-slot:empty>
          No warranties to show.
        </template>
      </c-data-list>
    </div>
  </div>
</template>

<script>
import { isEqual } from 'lodash'
import { mapState, mapActions } from 'vuex'
import WarrantiesListItem from './WarrantiesListItem'
import WarrantiesListFilters from './WarrantiesListFilters'

export default {
  components: {
    WarrantiesListItem,
    WarrantiesListFilters
  },

  data () {
    return {
      params: {}
    }
  },

  mounted () {
    this.getWarranties(this.params)

    this.$watch('params', async (params, oldParams) => {
      if (isEqual(params, oldParams)) {
        return
      }

      await this.getWarranties(params)
    })
  },

  computed: {
    ...mapState('warranty', { warranties: 'list' }),

    // The API has no unique id per warranty (stage_id is the stage type), so key rows by position
    rows () {
      return (this.warranties || []).map((warranty, index) => ({ ...warranty, key: index }))
    }
  },

  methods: {
    ...mapActions('warranty', { getWarranties: 'getList' })
  }
}
</script>
